<template>
  <div id="shopInfo">
    <div class="big-box">
      <div class="logo-box">
        <div>
          <el-avatar class="logo" :src="logo"></el-avatar>
        </div>
      </div>
      <router-link :to="bannerUrl != ''?bannerUrl :'/shop/shopInfo?id='+id" target="_blank">
        <div class="banner-box">
          <img class="banner" :src="banner" alt />
        </div>
      </router-link>

      <div class="table-box clearfix">
        <div
          class="table-item"
          v-for="(item,index) in tableData"
          :key="index"
          :class="(index + 1) % 5 == 0?'end-item':''"
          @click="routerProduct(item.id)"
        >
          <div class="top-img">
            <img :src="serve + item.images" alt />
          </div>
          <div class="title">{{item.title}}</div>
          <div class="price">￥{{item.selling_price}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      // serve: 'http://localhost',
      id: this.$route.query.id,
      logo: '',
      banner: '',
      tableData: [],
      pageEnd: true,
      page: 1,
      bannerUrl: ''
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollToTop)
  },
  created() {
    this.getImage()
    this.getShopProduct()
  },
  methods: {
    routerProduct(id) {
      var pathUrl = '/product/' + id
      let routerJump = this.$router.resolve({
        path: pathUrl
      })
      window.open(routerJump.href, '_blank')
    },
    scrollToTop() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (this.pageEnd && scrollTop / 600 > this.page) {
        this.page = this.page + 1
        this.getShopProduct()
      }
    },
    getImage() {
      var where = { id: this.id }
      this.axios
        .get(this.serve + '/shop/getImage', { params: where })
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
            if (data.data.logo == '') {
              this.logo = this.serve + '/webInfo/shopInfoLogo.png'
            } else {
              this.logo = this.serve + data.data.logo
            }
            if (data.data.banner == '') {
              this.bannerUrl = '/join'
              this.banner =
                this.serve + '/webInfo/shopInfoBanner.png'
            } else {
              this.banner = this.serve + data.data.banner
            }
          } else {
            this.bannerUrl = '/join'
            this.logo = this.serve + '/webInfo/shopInfoLogo.png'
            this.banner =
              this.serve + '/webInfo/shopInfoBanner.png'
          }
        })
    },
    getShopProduct() {
      var where = { id: this.id, page: this.page, limit: 10 }
      this.axios
        .get(this.serve + '/shop/getShopProduct', { params: where })
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
            if (this.tableData.length > 0) {
              for (let i in data.data) {
                this.tableData.push(data.data[i])
              }
            } else {
              this.tableData = data.data
            }
          } else {
            if (data.msg == '搜索结果为空') {
              this.pageEnd = false
            }
          }
        })
    }
  }
}
</script>
<style lang="scss">
#shopInfo {
  .clearfix:after  {
    content: '';
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
  width: 100%;
  min-height: 300px;
  border-top: 2px solid #e2211c;
  min-height: 1000px;
  background-image: url('https://www.bioflin.com:83/webInfo/shopInfoBg.png');
  background-repeat: no-repeat;
  .big-box {
    width: 1200px;
    margin: 30px auto 0 auto;
    padding-bottom: 20px;
    .logo-box {
      margin: 80px 0 40px 0;
      display: flex;
      justify-content: center;
      .logo {
        width: 158px;
        height: 158px;
        border: 3px solid #ffffff;
      }
    }
    .banner-box {
      width: 1200px;
      height: 220px;
      .banner {
        width: 1200px;
        height: 220px;
      }
    }
    .table-box {
      margin-top: 20px;
      width: 1200px;
      .table-item {
        float: left;
        margin-bottom: 20px;
        margin-right: 12px;
        width: 230px;
        height: 306px;
        background: rgba(255, 255, 255, 1);
        color: rgba(51, 51, 51, 1);
        cursor: pointer;
        .top-img {
          width: 190px;
          height: 185px;
          display: flex;
          padding: 20px 20px 0 20px;
          img {
            width: 190px;
            height: 185px;
          }
        }
        .title {
          width: 183px;
          height: 35px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 20px;
          margin: 10px auto 0 auto;
        }
        .price {
          width: 56px;
          height: 15px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(226, 33, 28, 1);
          margin: 18px auto 0 auto;
        }
      }
      .table-item:hover {
        color: #e2211c;
      }
      .end-item {
        margin-right: 0;
      }
    }
  }
}
</style>